import styled from "styled-components";

const Tabela = styled.table`
    width: 90%;
    justify-content: center;
    text-align: center;
    border-collapse: collapse;
    margin: auto;
    margin-top: 10px;
    margin-bottom: 40px;
    overflow-x: auto;
`
const LinhaTabela = styled.tr`
    border-bottom: 1px solid lightgray;
    height: ${props => props.$tamanho || "40px"};
`
const ColunaTabela = styled.td`
    width: ${props => props.$tamanho || "auto"};
    color: ${props => props.$cor || "#252525"};
    font-size: ${props => props.$tamFonte || "inherit"};
    font-weight: ${props => props.$bold || "normal"};

    .Icone {
        margin: 5px 5px 0 0;
        padding: 0;
    }
`

// Variável com os tipos de ingressos a serem mostrados na tabela
const tiposIngressos = [
    { tipo: "individuais", label: "Individuais" },
    { tipo: "individuaisOnline", label: "Indiv. online"},
    { tipo: "promocionaisExcursao", label: "Excursão" },
    { tipo: "promocionaisEscolar", label: "Escolar"},
    { tipo: "promocionais", label: "Prom." },
    { tipo: "promocionaisOnline", label: "Prom. online" }
];

export function TabelaPorGuia(dados) {
    try {
        return (
            <Tabela>
                <LinhaTabela>
                    <ColunaTabela $bold="bold">Guia</ColunaTabela>
                    <ColunaTabela $bold="bold">Total</ColunaTabela>
                    {tiposIngressos.map( item => {
                        return (<ColunaTabela $bold="bold">{item.label}</ColunaTabela>)
                    })}
                </LinhaTabela>
                {dados.guias.map((guia, indice) => {
                    const totalGuia = tiposIngressos.reduce( (total, item) => total + dados.quantidade[indice][item.tipo], 0);

                    // Não mostra guias que apenas tem cortesias
                    if (totalGuia <= 0) return;

                    return <LinhaTabela>
                        <ColunaTabela>{guia}</ColunaTabela>
                        <ColunaTabela>{totalGuia}</ColunaTabela>
                        {tiposIngressos.map( item => {
                            return (<ColunaTabela>{dados.quantidade[indice][item.tipo]}</ColunaTabela>)
                        })}
                    </LinhaTabela>
                })}
            </Tabela>
        );
    } catch (e) {
        console.log(e.message);
        return <></>
    }
}